import * as React from "react";
import { forwardRef } from "react";
const SvgMenuStroke = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3 5h14M3 10h14M3 15h14", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgMenuStroke);
export default ForwardRef;
